import { render, staticRenderFns } from "./ViewSubnavSection.vue?vue&type=template&id=61c1b32c&scoped=true&"
import script from "./ViewSubnavSection.vue?vue&type=script&lang=js&"
export * from "./ViewSubnavSection.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubnavSection.vue?vue&type=style&index=0&id=61c1b32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1b32c",
  null
  
)

export default component.exports